module.exports = __webpack_public_path__ + "fee48efa3a2618b2e0d403e36baa87a1.svg";